export default __webpack_public_path__ + "static/media/C0000.f2dd6f09.png";